export const TAXES_PRODUCTS = ["TXSV", "TXS"];

export const COMMISSIONS_PRODUCTS = ["RCOMLOC", "COMM", "COMETR", "COM2", "COM"];